import { faCheck, faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextField } from '@mui/material';
import axios from 'axios';
import Footer from 'components/Layout/Footer';
import { URL_API } from 'utils/globalConfig';
import React, { useState } from 'react';
import { useAlert } from 'react-alert';
import { Link, useNavigate } from 'react-router-dom';
import logoSanef from '../../images/logo.png';
import MyDialog from '../../components/Layout/MyDialog';
import MyLoader from '../../components/Layout/MyLoader';
import { logError } from '../../components/Utils/FormatData';

const Inscription = () => {
  const defaultForm = {
    num_siren: null,
    num_tva: null,
    new_password_1: null,
    new_password_2: null,
    raison_sociale: null,
    adresse: null,
    complement_adresse: null,
    code_postal: null,
    commune: null,
    pays: null,
    telephone_1: null,
    telephone_2: null,
    fax: null,
    email: null,
    id_profil: 6,
  };
  const [datas, setDatas] = useState(defaultForm);
  const alert = useAlert();
  const navigate = useNavigate();
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e, pattern) => {
    const regex = new RegExp(pattern);
    if (e.target.value === '' || regex.test(e.target.value)) {
      setDatas({ ...datas, [e.target.name]: e.target.value });
    }
  };
  const onConfirmationModalClose = (value) => {
    if (value) {
      clearForm();
      navigate('/');
    }
  };
  const clearForm = () => {
    setDatas(defaultForm);
  };
  const handleSubmit = () => {
    alert.removeAll();
    if (!datas.num_tva || !datas.email || !datas.raison_sociale || !datas.adresse || !datas.code_postal || !datas.commune || !datas.pays) {
      alert.error(`Vous devez renseigner l'ensemble des champs obligatoires avant de continuer`);
    } else {
      if (datas.email && !datas.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        alert.error(`L'adresse email n'est pas valide`);
        return;
      }

      if (datas.new_password_1 !== datas.new_password_2) {
        alert.error(`Les mots de passe ne sont pas identiques`);
        return;
      }

      if (datas.new_password_1 && datas.new_password_1.length < 12) {
          alert.error('Le mot de passe doit contenir au moins 12 caractères');
          return false;
      }

      if (datas.new_password_1 && !datas.new_password_1.match(/^(?=.*?[A-Z])(?=.*?[a-z])((?=.*?[0-9])|(?=.*?[#?!@$ %^&*-]))/)) {
        alert.error('Le mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre ou un caractère spécial');
        return false;
      }

      setLoading(true);
      axios({ method: 'post', url: URL_API + '/utilisateur/inscription', data: datas, params: { userAction: -1 } })
        .then(() => {
          setLoading(false);
          alert.success('La création du compte a bien été effectuée');
          setOpenConfirmationModal(true);
        })
        .catch((error) => {
          setLoading(false);
          logError(alert, error);
        });
    }
  };

  return (
    <div id='fond'>
      <MyLoader loading={loading} />
      <div id='filtre-rose' />
      <div id='card-inscription'>
        <div id='bloc-logo'><img id='logo' alt='' src={logoSanef} /></div>
        <div id='barre-rose' />
        <div className='libelle-form-connexion' id='barre-grise'>Transports exceptionnels</div>
        <div id='formulaire-inscription'>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>N° TVA intracommunautaire *</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e)}
              inputProps={{ maxLength: 14 }}
              name='num_tva'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.num_tva || ''}
              error={datas.num_tva === null || datas.num_tva === ''}
              required
            />
          </div>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>N° Siret {datas.num_tva === null || datas.num_tva === '' ? '*' : ''}</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e, '^[0-9]*$')}
              inputProps={{ maxLength: 14 }}
              name='num_siren'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.num_siren || ''}
              error={(datas.num_tva === null || datas.num_tva === '' && datas.num_siren === null || datas.num_siren === '')}
            />
          </div>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>Raison sociale *</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e)}
              name='raison_sociale'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.raison_sociale || ''}
              error={datas.raison_sociale === null || datas.raison_sociale === ''}
              required
            />
          </div>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>Adresse *</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e)}
              name='adresse'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.adresse || ''}
              error={datas.adresse === null || datas.adresse === ''}
              required
            />
          </div>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>Complément d'adresse</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e)}
              name='complement_adresse'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.complement_adresse || ''}
            />
          </div>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>Code postal *</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e, '^[a-zA-Z0-9]*$')}
              name='code_postal'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.code_postal || ''}
              error={datas.code_postal === null || datas.code_postal === ''}
              required
            />
          </div>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>Commune *</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e)}
              name='commune'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.commune || ''}
              error={datas.commune === null || datas.commune === ''}
              required
            />
          </div>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>Pays *</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e)}
              name='pays'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.pays || ''}
              error={datas.pays === null || datas.pays === ''}
              required
            />
          </div>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>Email *</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e)}
              name='email'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.email || ''}
              error={datas.email === null || datas.email === ''}
              required
            />
          </div>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>Téléphone 1</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e, '^[0-9]*$')}
              inputProps={{ maxLength: 12 }}
              name='telephone_1'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.telephone_1 || ''}
            />
          </div>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>Téléphone 2</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e, '^[0-9]*$')}
              inputProps={{ maxLength: 12 }}
              name='telephone_2'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.telephone_2 || ''}
            />
          </div>
          <div>
            <img className='panneau' alt='' />
            <span className='libelle-form-connexion'>Fax</span>
            <TextField
              style={{ marginLeft: '30px', marginTop: '10px' }}
              className='champ'
              onChange={(e) => handleChange(e)}
              name='fax'
              autoComplete='off'
              variant='outlined'
              size='small'
              value={datas.fax || ''}
            />
          </div>
        </div>
        <div id='buttons-actions-connexion'>
          <Link to='/' style={{ textDecoration: 'none' }}>
            <button id='btn-connexion' type='button'>
              <span className='error'><FontAwesomeIcon icon={faSignInAlt} /></span>
              <span className='libelle-form-connexion'>Annuler</span>
            </button>
          </Link>
          <button id='btn-inscription' type='submit' onClick={() => handleSubmit()}>
            <span className='error'><FontAwesomeIcon icon={faCheck} /></span>
            <span className='libelle-form-connexion'>Valider l'inscription</span>
          </button>

        </div>
      </div>
      <Footer />
      <MyDialog
        open={openConfirmationModal}
        handleClose={setOpenConfirmationModal}
        title={'Votre compte a été créé !'}
        content={'Votre demande d\'inscription a été enregistrée. Vous recevrez un mail contenant vos identifiants dès que votre compte sera validé.\n' +
            'Your registration request has been recorded. You will receive an email containing your identifiers as soon as your account is validated.'}
        dialog={onConfirmationModalClose}
        hideCloseBtn={true}
      />
    </div>
  );
};

export default Inscription;
